import React from 'react';
import DashboardView from '../../views/Dashboard/DashboardView';

const DashboardUseCase = ({ dashboardId }) => {
  if (!dashboardId) {
    return null;
  }

  return <DashboardView dashboardId={dashboardId} />;
    // return (
    // <div className="mt-8">
    //     Dashboard ID: {dashboardId}
    // </div>
    // );

};

export default DashboardUseCase;